// Materials configuration for PLANIMETRIK
// 8 material types with formats, installation types, adhesives, tools, and comparator data

export const MATERIALS = {
  suelo_laminado: {
    name: "Suelo laminado",
    formats: ["Lama", "Loseta"],
    installationTypes: {
      Lama: ["Flotante", "Pegado"],
      Loseta: ["Flotante", "Pegado"],
    },
    soldaduraApplicable: false,
    esdApplicable: false,
    priceRange: [12, 35],
    comparator: { durability: 3, waterResistance: 2, maintenance: "Bajo", sustainability: "Media" },
  },
  parquet: {
    name: "Parquet",
    formats: ["Lama", "Loseta"],
    installationTypes: {
      Lama: ["Flotante", "Pegado"],
      Loseta: ["Flotante", "Pegado"],
    },
    soldaduraApplicable: false,
    esdApplicable: false,
    priceRange: [25, 80],
    comparator: { durability: 4, waterResistance: 1, maintenance: "Alto", sustainability: "Alta" },
  },
  suelo_vinilico: {
    name: "Suelo vinílico",
    formats: ["Rollo", "Lama", "Loseta"],
    installationTypes: {
      Rollo: ["Pegado", "Autoportante"],
      Lama: ["Pegado", "Autoportante"],
      Loseta: ["Pegado", "Autoportante"],
    },
    soldaduraApplicable: true,
    esdApplicable: true,
    priceRange: [15, 45],
    comparator: { durability: 4, waterResistance: 5, maintenance: "Muy bajo", sustainability: "Media" },
  },
  lvt: {
    name: "LVT",
    formats: ["Lama", "Loseta"],
    installationTypes: {
      Lama: ["Pegado (dryback)", "Autoportante (loose lay)", "Flotante (SPC/WPC/LVT click)"],
      Loseta: ["Pegado (dryback)", "Autoportante (loose lay)", "Flotante (SPC/WPC/LVT click)"],
    },
    soldaduraApplicable: false,
    esdApplicable: false,
    priceRange: [18, 50],
    comparator: { durability: 5, waterResistance: 5, maintenance: "Muy bajo", sustainability: "Media-Alta" },
  },
  moqueta: {
    name: "Moqueta",
    formats: ["Rollo", "Lama", "Loseta"],
    installationTypes: {
      Rollo: ["Pegado", "Autoportante", "Tensada"],
      Lama: ["Pegado", "Autoportante", "Tapes tiles"],
      Loseta: ["Pegado", "Autoportante", "Tapes tiles"],
    },
    soldaduraApplicable: false,
    esdApplicable: false,
    priceRange: [8, 30],
    comparator: { durability: 2, waterResistance: 1, maintenance: "Alto", sustainability: "Baja" },
  },
  linoleo: {
    name: "Linóleo",
    formats: ["Rollo", "Lama", "Loseta"],
    installationTypes: {
      Rollo: ["Pegado", "Autoportante"],
      Lama: ["Pegado", "Flotante (click)"],
      Loseta: ["Pegado", "Flotante (click)"],
    },
    soldaduraApplicable: true,
    esdApplicable: true,
    priceRange: [20, 55],
    comparator: { durability: 4, waterResistance: 1, maintenance: "Medio", sustainability: "Muy alta" },
  },
  tarima_exterior: {
    name: "Tarima de exterior",
    formats: ["Lama"],
    installationTypes: {
      Lama: ["Grapa atornillada", "Clip"],
    },
    soldaduraApplicable: false,
    esdApplicable: false,
    priceRange: [30, 90],
    comparator: { durability: 4, waterResistance: 2, maintenance: "Alto", sustainability: "Alta" },
  },
  cesped_artificial: {
    name: "Césped artificial",
    formats: ["Rollo"],
    installationTypes: {
      Rollo: ["Sobre pavimento", "Sobre tierra"],
    },
    soldaduraApplicable: false,
    esdApplicable: false,
    priceRange: [10, 40],
    comparator: { durability: 3, waterResistance: 5, maintenance: "Medio", sustainability: "Media" },
  },
};

// Adhesive configurations indexed by material_installation key
export const ADHESIVES = {
  // Suelo laminado
  "suelo_laminado_Flotante": { type: "base_aislante", name: "Base aislante", unit: "m2" },
  "suelo_laminado_Pegado": { type: "adhesive", name: "Adhesivo MS polímero", consumption: 1250, containerSize: 21, containerUnit: "kg", containerName: "bidón" },
  // Parquet
  "parquet_Flotante": { type: "base_aislante", name: "Base aislante", unit: "m2" },
  "parquet_Pegado": { type: "adhesive", name: "Adhesivo MS polímero", consumption: 1250, containerSize: 21, containerUnit: "kg", containerName: "bidón" },
  // Suelo vinílico
  "suelo_vinilico_Pegado": { type: "adhesive", name: "Adhesivo acrílico en dispersión", consumption: 325, containerSize: 20, containerUnit: "kg", containerName: "bidón" },
  "suelo_vinilico_Autoportante": { type: "tape", name: "Cinta de doble cara", consumption: 1.15, containerSize: 25, containerUnit: "ml", containerName: "rollo" },
  "suelo_vinilico_Pegado_ESD": { type: "adhesive", name: "Adhesivo conductor acrílico", consumption: 450, containerSize: 14, containerUnit: "kg", containerName: "bidón" },
  // LVT
  "lvt_Pegado (dryback)": { type: "adhesive", name: "Adhesivo acrílico en dispersión", consumption: 300, containerSize: 20, containerUnit: "kg", containerName: "bidón" },
  "lvt_Autoportante (loose lay)": { type: "adhesive", name: "Fijador acrílico en tack", consumption: 70, containerSize: 5, containerUnit: "kg", containerName: "bidón" },
  "lvt_Flotante (SPC/WPC/LVT click)": { type: "base_aislante", name: "Base aislante", unit: "m2" },
  // Moqueta Rollo
  "moqueta_Rollo_Pegado": { type: "adhesive", name: "Adhesivo acrílico en dispersión", consumption: 325, containerSize: 20, containerUnit: "kg", containerName: "bidón" },
  "moqueta_Rollo_Autoportante": { type: "tape", name: "Cinta de doble cara", consumption: 1.15, containerSize: 25, containerUnit: "ml", containerName: "rollo" },
  "moqueta_Rollo_Tensada": { type: "none", name: "Sin adhesivo (instalaci\u00f3n tensada)" },
  // Moqueta Lama/Loseta
  "moqueta_Loseta_Pegado": { type: "adhesive", name: "Adhesivo acrílico en dispersión", consumption: 325, containerSize: 20, containerUnit: "kg", containerName: "bidón" },
  "moqueta_Lama_Pegado": { type: "adhesive", name: "Adhesivo acrílico en dispersión", consumption: 325, containerSize: 20, containerUnit: "kg", containerName: "bidón" },
  "moqueta_Loseta_Autoportante": { type: "adhesive", name: "Fijador acrílico en tack", consumption: 70, containerSize: 5, containerUnit: "kg", containerName: "bidón" },
  "moqueta_Lama_Autoportante": { type: "adhesive", name: "Fijador acrílico en tack", consumption: 70, containerSize: 5, containerUnit: "kg", containerName: "bidón" },
  "moqueta_Loseta_Tapes tiles": { type: "tapes", name: "Tapes tiles", stickersPerRoll: 324 },
  "moqueta_Lama_Tapes tiles": { type: "tapes", name: "Tapes tiles", stickersPerRoll: 324 },
  // Linóleo Rollo
  "linoleo_Rollo_Pegado": { type: "adhesive", name: "Adhesivo acrílico en dispersión", consumption: 325, containerSize: 20, containerUnit: "kg", containerName: "bidón" },
  "linoleo_Rollo_Autoportante": { type: "tape", name: "Cinta de doble cara", consumption: 1.15, containerSize: 25, containerUnit: "ml", containerName: "rollo" },
  // Linóleo Lama/Loseta
  "linoleo_Loseta_Pegado": { type: "adhesive", name: "Adhesivo acrílico en dispersión", consumption: 325, containerSize: 20, containerUnit: "kg", containerName: "bidón" },
  "linoleo_Lama_Pegado": { type: "adhesive", name: "Adhesivo acrílico en dispersión", consumption: 325, containerSize: 20, containerUnit: "kg", containerName: "bidón" },
  "linoleo_Loseta_Flotante (click)": { type: "base_aislante", name: "Base aislante", unit: "m2" },
  "linoleo_Lama_Flotante (click)": { type: "base_aislante", name: "Base aislante", unit: "m2" },
  // Tarima exterior
  "tarima_exterior_Grapa atornillada": {
    type: "hardware",
    items: [
      { name: "Grapa + tornillo", factor: 22, unit: "unidades" },
      { name: "Rastrel", factor: 3.5, unit: "ml", containerSize: 2.2, containerName: "rastrel" },
    ],
  },
  "tarima_exterior_Clip": {
    type: "hardware",
    items: [
      { name: "Clip", factor: 25, unit: "unidades" },
      { name: "Rastrel aluminio", factor: 3.5, unit: "ml", containerSize: 2.2, containerName: "rastrel" },
    ],
  },
  // Césped artificial
  "cesped_artificial_Sobre pavimento": { type: "cesped_tape", name: "Cinta césped artificial", containerSize: 5, containerUnit: "ml" },
  "cesped_artificial_Sobre tierra": { type: "cesped_tape_mesh", name: "Cinta césped artificial", containerSize: 5, containerUnit: "ml" },
};

// Tool lists by material+installation combination
export const TOOL_LISTS = {
  "suelo_laminado_Flotante": {
    medición: [
      "Distanciómetro láser + cinta métrica profesional",
      "Láser de líneas (alineación primera fila y escuadras)",
      "Escuadra metálica + falsa escuadra",
      "Regla 2m + galgas de espesores",
      "Medidor de humedad y termohigrómetro",
    ],
    corte: [
      "Sierra ingletadora con disco fino para laminado",
      "Sierra circular de inmersión con rail",
      "Sierra de calar profesional con hojas específicas",
      "Multiherramienta oscilante",
      "Sierra de corte inferior para jambas",
      "Kit instalaci\u00f3n: taco de golpeo, barra de tracci\u00f3n, mazo goma blanca, cu\u00f1as",
    ],
    acabado: [
      "Clavadora de acabado + compresor o pistola de adhesivo",
      "Taladro/atornillador (perfiles transición)",
      "Pistola de sellador (sellados perimetrales)",
    ],
  },
  "suelo_laminado_Pegado": {
    medición: [
      "Distanciómetro láser + cinta métrica profesional",
      "Láser de líneas",
      "Escuadra metálica + falsa escuadra",
      "Regla 2m + galgas de espesores",
      "Medidor de humedad y termohigrómetro",
    ],
    corte: [
      "Sierra ingletadora con disco fino",
      "Sierra circular de inmersión con rail",
      "Sierra de calar profesional",
      "Multiherramienta oscilante",
      "Sierra de corte inferior para jambas",
      "Llana dentada para parquet (B11/B3)",
      "Llana lisa (remates)",
      "Espátula/rasqueta para adhesivo fresco",
    ],
    acabado: [
      "Clavadora de acabado + compresor",
      "Taladro/atornillador",
      "Pistola de sellador",
    ],
  },
  "parquet_Flotante": {
    medición: [
      "Distanciómetro láser + cinta métrica profesional",
      "Láser de líneas",
      "Escuadra metálica + falsa escuadra",
      "Regla 2m + galgas de espesores",
      "Medidor de humedad y termohigrómetro",
    ],
    corte: [
      "Sierra ingletadora con disco fino",
      "Sierra circular de inmersión con rail",
      "Sierra de calar profesional",
      "Multiherramienta oscilante",
      "Sierra de corte inferior para jambas",
      "Kit instalaci\u00f3n clic: taco, barra tracci\u00f3n, mazo, cu\u00f1as",
    ],
    acabado: [
      "Clavadora de acabado + compresor",
      "Taladro/atornillador",
      "Pistola de sellador",
    ],
  },
  "parquet_Pegado": {
    medición: [
      "Láser de líneas + cordex (ejes y alineación)",
      "Regla 2m + galgas (planeidad)",
      "Medidor de humedad soporte + madera",
      "Termohigrómetro",
      "Calibre/galga juntas dilatacion perimetral",
    ],
    corte: [
      "Ingletadora + disco madera",
      "Sierra inmersión con rail",
      "Caladora y multiherramienta",
      "Llana dentada para parquet (B11/B3)",
      "Llana lisa",
      "Espátula/rasqueta adhesivo fresco",
      "Mazo goma blanca, taco golpeo, barra tracción",
      "Rodillo de presión",
      "Aspiracion industrial",
    ],
    acabado: [
      "Cortadora de jambas / multiherramienta",
      "Clavadora de acabado + compresor",
      "Si parquet en bruto: lijadora + canteadora + aspirador + aplicadores barniz/aceite",
    ],
  },
  "suelo_vinilico_Rollo_Pegado": {
    medición: [
      "Distanciómetro + cinta",
      "Láser de líneas + cordex",
      "Regla metálica 2m + escuadra larga",
      "Compás de corte / scribing",
      "Control soporte: regla 2m/galgas + humedad",
    ],
    corte: [
      "Cuchillo profesional vinilo + cuchilla trapezoidal/gancho",
      "Cortador de juntas (seam cutter)",
      "Rodillo presor juntas + rodillo manual perímetros",
      "Llana dentada TKB (A2/B1/B2)",
      "Rodillo 50-70 kg (imprescindible)",
    ],
    acabado: [
      "Rodillo manual esquinas y perímetros",
      "Pistola de sellador",
      "Perfiles transición: taladro/atornillador",
    ],
  },
  "suelo_vinilico_Rollo_Autoportante": {
    medición: [
      "Distanciómetro + cinta",
      "Láser de líneas + cordex",
      "Regla metálica 2m + escuadra larga",
      "Compás de corte / scribing",
      "Control soporte: regla 2m/galgas + humedad",
    ],
    corte: [
      "Cuchillo profesional (trapezoidal + gancho) + regla 2m",
      "Cortador de juntas + rodillo juntas",
      "Rodillo 50-70 kg",
      "Dispensador cinta doble cara profesional",
      "Rodillo presor cintas y perímetros",
    ],
    acabado: [
      "Rodillo manual perímetros",
      "Perfiles y remates (taladro/atornillador)",
      "Pistola sellador zonas humedas",
    ],
  },
  "suelo_vinilico_Lama_Pegado": {
    medición: [
      "Láser de líneas + cordex (cuadricula y ejes)",
      "Escuadra larga / escuadra de solador",
      "Regla metálica + galgas",
      "Control soporte: humedad y condiciones",
    ],
    corte: [
      "Cortadora guillotina profesional LVT/vinilo",
      "Cuchillo profesional (gancho) + cuchillas recambio",
      "Llana dentada (A1/A2)",
      "Rodillo 50 kg + rodillo manual",
    ],
    acabado: [
      "Rodillo manual (repaso bordes)",
      "Perfiles y transiciónes: taladro/atornillador + cortadora perfiles",
    ],
  },
  "lvt_Pegado (dryback)": {
    medición: [
      "Láser de líneas + cordex",
      "Escuadra de solador / escuadra larga",
      "Regla 2m + galgas (planitud exigente)",
      "Control soporte (humedad/HR + temperatura)",
    ],
    corte: [
      "Guillotina profesional LVT",
      "Cuchillo profesional (gancho y trapezoidal)",
      "Llana dentada TKB A1/A2",
      "Rodillo 50-70 kg + rodillo manual",
      "Multiherramienta oscilante",
    ],
    acabado: [
      "Perfiles y rodapie: clavadora/pistola adhesivo, taladro",
    ],
  },
  "lvt_Autoportante (loose lay)": {
    medición: [
      "Láser de líneas + cordex (cuadricula y ejes)",
      "Escuadra larga",
      "Regla 2m + galgas (planitud critica)",
    ],
    corte: [
      "Guillotina LVT + cuchillo profesional",
      "Rodillo 50-70 kg",
      "Rodillo espuma fino",
    ],
    acabado: [
      "Perfiles y rodapie: clavadora/pistola adhesivo, taladro",
    ],
  },
  "lvt_Flotante (SPC/WPC/LVT click)": {
    medición: [
      "Distanciómetro + láser de líneas + escuadra",
      "Regla 2m + galgas (rigidez SPC)",
      "Medici\u00f3n humedad soporte y control ambiental",
    ],
    corte: [
      "Ingletadora / sierra circular disco fino",
      "Sierra calar + multiherramienta",
      "Sierra corte inferior jambas",
      "Kit instalaci\u00f3n clic: cu\u00f1as, barra, mazo, cu\u00f1as separadoras",
    ],
    acabado: [
      "Clavadora/pistola adhesivo, taladro/atornillador",
    ],
  },
  "moqueta_Rollo_Pegado": {
    medición: ["Distanciómetro + cinta profesional", "Láser líneas + cordex", "Escuadra larga", "Plantillas columnas/entradas"],
    corte: ["Cuchillo moqueta profesional + cuchillas gancho/trapezoidal", "Regla guia aluminio", "Cortador juntas", "Llana dentada (A2/B1)", "Rodillo moqueta + rodillo manual"],
    acabado: ["Recortador perímetros / wall tool", "Herramienta escaleras (si aplica)", "Aspirador profesional"],
  },
  "moqueta_Rollo_Autoportante": {
    medición: ["Distanciómetro + cinta", "Láser líneas + cordex", "Escuadra larga", "Plantillas"],
    corte: ["Cuchillo moqueta + regla guia", "Dispensador cinta doble cara + rodillo presión", "Plancha juntas + rodillo juntas"],
    acabado: ["Recortador perímetros", "Rodillo manual juntas/perímetros", "Aspirador profesional"],
  },
  "moqueta_Rollo_Tensada": {
    medición: ["Distanciómetro + cinta", "Láser líneas + cordex", "Escuadra larga", "Plantillas"],
    corte: ["Gripper strips: herramienta corte + martillo profesional", "Knee kicker", "Power stretcher profesional con tubos", "Recortador pared / wall cutter"],
    acabado: ["Recortador perímetros", "Rodillo manual juntas/perímetros", "Aspirador profesional"],
  },
  "moqueta_Loseta_Pegado": {
    medición: ["Láser líneas + cordex cuadricula", "Escuadra larga", "Marcadores finos ejes y orientación"],
    corte: ["Cortadora guillotina losetas moqueta o cuchillo + escuadra metal", "Llana dentada (A2/B1)", "Rodillo moqueta + rodillo manual"],
    acabado: ["Recortador perímetros", "Aspirador profesional"],
  },
  "moqueta_Loseta_Autoportante": {
    medición: ["Láser líneas + cordex cuadricula", "Escuadra larga", "Marcadores finos"],
    corte: ["Cortadora guillotina o cuchillo + escuadra", "Rodillo espuma/pelo corto para fijador", "Rodillo 50 kg + rodillo manual perímetros"],
    acabado: ["Recortador perímetros", "Aspirador profesional"],
  },
  "moqueta_Loseta_Tapes tiles": {
    medición: ["Láser líneas + cordex cuadricula", "Escuadra larga", "Marcadores finos"],
    corte: ["Cortadora guillotina o cuchillo + escuadra", "Rodillo 50 kg + rodillo manual perímetros"],
    acabado: ["Recortador perímetros", "Aspirador profesional"],
  },
  "linoleo_Rollo_Pegado": {
    medición: ["Distanciómetro + cinta", "Láser líneas + cordex", "Regla metálica 2m + escuadra larga", "Compás de corte / scribing", "Control soporte: regla 2m/galgas + humedad"],
    corte: ["Cuchillo profesional vinilo + cuchilla trapezoidal/gancho", "Cortador juntas (seam cutter)", "Rodillo presor juntas + rodillo manual", "Llana dentada TKB (A2/B1/B2)", "Rodillo 50-70 kg"],
    acabado: ["Rodillo manual esquinas/perímetros", "Pistola sellador", "Perfiles transición: taladro/atornillador"],
  },
  "linoleo_Rollo_Autoportante": {
    medición: ["Distanciómetro + cinta", "Láser líneas + cordex", "Regla metálica 2m + escuadra larga", "Compás corte / scribing", "Control soporte"],
    corte: ["Cuchillo profesional (trapezoidal + gancho) + regla 2m", "Cortador juntas + rodillo juntas", "Rodillo 50-70 kg", "Dispensador cinta doble cara", "Rodillo presor cintas/perímetros"],
    acabado: ["Rodillo manual perímetros", "Perfiles y remates", "Pistola sellador zonas humedas"],
  },
  "linoleo_Loseta_Pegado": {
    medición: ["Láser líneas + cordex cuadricula", "Escuadra larga", "Regla 2m + galgas", "Control humedad soporte"],
    corte: ["Guillotina o cuchillo profesional + escuadra metal", "Adhesivo: llana dentada A2", "Rodillo 50 kg + rodillo manual", "Rodillo presor juntas"],
    acabado: ["Repaso rodillo", "Perfiles y remates", "Sellador perimetral si aplica"],
  },
  "linoleo_Loseta_Flotante (click)": {
    medición: ["Distanciómetro + láser líneas", "Escuadra/ingleteadora", "Regla 2m + galgas", "Medición humedad soporte"],
    corte: ["Ingletadora / sierra circular inmersión (paneles HDF)", "Sierra calar + multiherramienta", "Sierra corte inferior jambas", "Kit clic: cunas, barra, mazo, cunas separadoras"],
    acabado: ["Perfiles/rodapie: ingletadora, clavadora/pistola adhesivo, taladro"],
  },
  "tarima_exterior_Grapa atornillada": {
    medición: ["Láser rotativo + mira (niveles y pendientes)", "Láser de líneas (alineación rastreles)", "Cuerdas y cordex", "Escuadra + falsa escuadra", "Medidor humedad madera", "Calibres/galgas separación"],
    corte: ["Ingletadora (cortes transversales)", "Sierra circular / inmersión (longitudinales)", "Sierra calar (recortes)", "Fresadora (acabados, bordes)", "Taladro/atornillador profesional + atornillador impacto", "Brocas madera/metal + avellanadores", "Taladro percutor SDS (soporte mineral)", "Herramienta alineación / board straightener"],
    acabado: ["Lijadora orbital + aspiración", "Herramientas sellado cabezas (madera natural)", "Cortadora perfiles/remates", "Pistola sellador juntas pared"],
  },
  "tarima_exterior_Clip": {
    medición: ["Láser rotativo + mira", "Láser de líneas", "Cuerdas y cordex", "Escuadra + falsa escuadra", "Medidor humedad madera", "Calibres/galgas separación"],
    corte: ["Ingletadora", "Sierra circular / inmersión", "Sierra calar", "Fresadora", "Taladro/atornillador + impacto", "Brocas + avellanadores", "Taladro percutor SDS", "Herramienta clip / guia + soportes/separadores", "Herramienta alineación"],
    acabado: ["Lijadora orbital + aspiración", "Sellado cabezas", "Cortadora perfiles", "Pistola sellador"],
  },
  "cesped_artificial_Sobre pavimento": {
    medición: ["Distanciómetro + cinta larga (30-50m)", "Cuerdas/tiralíneas (ejes y alineación)", "Láser rotativo o líneas (pendientes)", "Plantillas recortes"],
    corte: ["Cuchillo profesional cuchilla gancho + trapezoidal", "Regla larga / guia corte", "Llana dentada B2/B3 (adhesivo PU en cintas)", "Rodillo presión juntas", "Cinta juntas y cinta doble cara dispensador"],
    acabado: ["Groomer / cepillo mecánico", "Soplador profesional", "Cuchillo + sellador/adhesivo perimetral"],
  },
  "cesped_artificial_Sobre tierra": {
    medición: ["Distanciómetro + cinta larga (30-50m)", "Cuerdas/tiralíneas", "Láser rotativo o líneas", "Plantillas recortes"],
    corte: ["Cuchillo profesional cuchilla gancho + trapezoidal", "Regla larga / guia corte", "Placa vibratoria / compactador", "Reglas aluminio extendido y nivelación", "Rastrillos obra y rastrillo nivelador", "Llana dentada B2/B3", "Rodillo presión juntas", "Grapadora profesional o clavos galvanizados"],
    acabado: ["Esparcidor material relleno (si aplica)", "Barredora mecánica / groomer", "Soplador profesional", "Cuchillo + sellador perimetral"],
  },
};

// Leveling tools
export const LEVELING_TOOLS = {
  medici\u00f3n: [
    "L\u00e1ser rotativo + mira (nivel y pendientes)",
    "Regla 2m + galgas (pre y post-control)",
    "Marcadores nivel (pins o marcadores l\u00e1ser)",
    "Rastrillo regulable con control altura (mm)",
    "Peines/galgas espesor (control r\u00e1pido)",
  ],
  mezclado: [
    "Mezclador el\u00e9ctrico alta torsi\u00f3n (min 1600W) + h\u00e9lice apropiada",
    "Estaci\u00f3n mezcla (cubo + soporte + control agua)",
    "Cubos/bidones graduados + medidor litros",
  ],
  vertido: [
    "Llana alisadora (smoothing trowel)",
    "Rastrillo regulable (distribuci\u00f3n y espesor)",
    "Rodillo de p\u00faas (desaireaci\u00f3n) + rodillo peque\u00f1o per\u00edmetros",
    "Zapatos de p\u00faas",
    "Llana esquina / esp\u00e1tula per\u00edmetros, columnas",
  ],
  curado: [
    "Termohigr\u00f3metro y control ambiental",
    "Medici\u00f3n humedad (CM/RH in-situ)",
    "Aspirador industrial clase M",
  ],
};

// Welding tools (when soldadura t\u00e9rmica is enabled)
export const WELDING_TOOLS = [
  "Ranuradora (manual o el\u00e9ctrica) para cord\u00f3n",
  "Soldador de aire caliente con control temperatura + boquilla velocidad",
  "Cortador de cord\u00f3n (desbaste + acabado) + cuchilla media luna con gu\u00eda",
];

// Room types for AI detection
export const ROOM_TYPES = [
  "Baño",
  "Cocina",
  "Salón/Comedor",
  "Dormitorio",
  "Oficina/Comercial",
  "Zona de paso/Pasillo",
  "Exterior/Terraza",
];

// Material recommendations by room type
export const ROOM_RECOMMENDATIONS = {
  "Baño": ["Suelo vinílico", "LVT"],
  "Cocina": ["Suelo vinílico", "LVT", "Linóleo"],
  "Salón/Comedor": ["Parquet", "Suelo laminado", "LVT"],
  "Dormitorio": ["Parquet", "Suelo laminado", "Moqueta"],
  "Oficina/Comercial": ["LVT", "Suelo vinílico", "Moqueta"],
  "Zona de paso/Pasillo": ["LVT", "Suelo vinílico", "Suelo laminado"],
  "Exterior/Terraza": ["Tarima de exterior", "Césped artificial"],
};

export const UNITS = ["m", "cm", "mm"];
export const UNIT_FACTORS = { m: 1, cm: 0.01, mm: 0.001 };
